export default __webpack_public_path__ + "static/media/Shopee2021-Bold.c18473da.ttf";